import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgRefer = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M10.71 4.779a3.43 3.43 0 0 1 2-.64 3.425 3.425 0 0 1 3.435 3.417 3.42 3.42 0 0 1-2.962 3.384.75.75 0 1 1-.204-1.486 1.92 1.92 0 0 0 1.666-1.898 1.925 1.925 0 0 0-1.934-1.917c-.424 0-.813.134-1.13.36a.75.75 0 1 1-.872-1.22M8.236 7.417a1.926 1.926 0 0 0-1.934 1.916c0 1.054.86 1.917 1.934 1.917a1.925 1.925 0 0 0 1.934-1.917 1.925 1.925 0 0 0-1.934-1.916M4.803 9.333a3.425 3.425 0 0 1 3.434-3.416 3.425 3.425 0 0 1 3.434 3.416 3.425 3.425 0 0 1-3.434 3.417 3.425 3.425 0 0 1-3.434-3.417M19.5 7.75a.75.75 0 0 1 .75.75v1.75H22a.75.75 0 0 1 0 1.5h-1.75v1.75a.75.75 0 0 1-1.5 0v-1.75H17a.75.75 0 0 1 0-1.5h1.75V8.5a.75.75 0 0 1 .75-.75m-6.451 4.842h.065c3.82.166 5.508 2.654 6.175 4.195.236.544.14 1.113-.175 1.532a1.67 1.67 0 0 1-1.34.653h-1.485a.75.75 0 1 1 0-1.5h1.485c.085 0 .128-.037.141-.054l.005-.009a.1.1 0 0 0-.007-.025c-.54-1.245-1.826-3.148-4.832-3.292-.48.023-.913.09-1.302.19a.75.75 0 1 1-.373-1.453 8 8 0 0 1 1.643-.237m-4.812 3.27c-3.278 0-4.644 2.01-5.202 3.298a.1.1 0 0 0-.008.026q0 .003.006.01c.013.017.056.054.14.054H13.3c.085 0 .128-.037.14-.054l.006-.01a.1.1 0 0 0-.007-.026c-.559-1.289-1.925-3.299-5.202-3.299m-6.578 2.702c.693-1.6 2.48-4.203 6.578-4.203 4.097 0 5.885 2.603 6.578 4.203.236.544.14 1.113-.174 1.532-.306.408-.8.654-1.34.654H3.172c-.54 0-1.034-.246-1.34-.654a1.52 1.52 0 0 1-.174-1.532"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgRefer;
